import { TransactionIdentifier } from '@/generated/proto/bridge/models/transaction'
import { ProtobufAnyMessage } from '@/types'

export type RemoveTransactionFormValues = {
  creator: string
} & TransactionIdentifier

export function buildRemoveTransactionMessage(
  values: RemoveTransactionFormValues,
): {
  messages: ProtobufAnyMessage[]
} {
  return {
    messages: [
      {
        '@type': '/core.bridge.MsgRemoveTransaction',
        creator: values.creator,
        depositChainId: values.depositChainId,
        depositTxHash: values.depositTxHash,
        depositTxIndex: values.depositTxIndex,
      },
    ],
  }
}
